<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left">
    <form [formGroup]="codeForm" (ngSubmit)="onSubmit()" class="wrapper-verify-account">
      <div class="verify-account-page">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-verify-account">
          <h1>{{'NEW_TEXT.verify_account' | translate}}</h1>
          <h6>Please enter your code.</h6>
<!--          <h6>{{'NEW_TEXT.lastly_please_check_your_email_and_enter_the_verification_code_weve_sent' | translate}}</h6>-->
        </div>
        <div class="wrapper-verify-phone-account">
          <div class="show-phone">
            <p>{{'CREATE_ACCOUNT.weve_send_you_the_verification_code_on' | translate}}</p>
            <div class="phone-holder">
              <p>{{ authHelperService.getUserPhone }}</p>
              <span (click)="showChangePhone = !showChangePhone">{{!showChangePhone ? 'Change number' : 'Keep this number'}}</span>
            </div>
          </div>
          <div *ngIf="showChangePhone" class="wrapper-input" [ngClass]="{'error': codeForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.phone_number' | translate}}</span>
            <div class="wrapper-phone-number open" [ngClass]="{'open': isAreaCodeOpen}">
              <div #areaCodeBtn class="wrapper-flags" (click)="isAreaCodeOpen = !isAreaCodeOpen">
                <img class="icon-flag" [src]="'../../../../assets/icons/flags/' + selectedArea.code.toLowerCase() + '.png'" alt="">
                <img class="icon-arrow-flags" src="../../../assets/icons/icon-arrow-left.svg" alt="">
              </div>
              <div class="wrapper-number-country">
                <span>{{selectedArea.phone_code}}</span>
              </div>
              <input type="text" formControlName="phone_number">
              <div class="content-dropdown-phone-number" *ngIf="isAreaCodeOpen">
                <div class="item-dropdown-phone-number" *ngFor="let country of Countries" (click)="onSelectCodeArea(country)">
                  <img [src]="'../../../../assets/icons/flags/' + country.code.toLowerCase() + '.png'" alt="">
                  <span>{{country.name}} ({{country.phone_code}})</span>
                </div>
              </div>
            </div>
            <div *ngIf="codeForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.' : formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{codeForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}}</span>
            </div>
          </div>
        </div>
        <div class="wrapper-verify-code" [ngClass]="{'error': isCodeError}" *ngIf="!showChangePhone">
          <input
            #codeInput
            *ngFor="let digit of codeArray; let i = index"
            [formControlName]="'code' + i"
            (input)="onInput($event, i)"
            (keydown)="onKeyDown($event, i)"
            (paste)="onPaste($event)"
            [autofocus]="i === 0"
            inputmode="numeric"
            maxlength="1"
            type="text">
        </div>
        <div *ngIf="isCodeError" class="error-message">
          <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
          <span>{{'NEW_TEXT.wrong_code_please_enter_a_valid_code' | translate}}</span>
        </div>
        <div class="wrapper-label-link"  *ngIf="!showChangePhone">
          <span>{{'CREATE_ACCOUNT.didnt_get_the_code' | translate}}?</span>
          <a href="javascript:void(0)" (click)="resendVerificationCode()">{{'NEW_TEXT.resend' | translate}}<span
            *ngIf="numberOfSecondsToEnableResendCodeBtn">({{numberOfSecondsToEnableResendCodeBtn + ' sec'}})</span></a>
        </div>
      </div>
      <button *ngIf="!showChangePhone" type="submit" class="custom-btn custom-btn--primary" [disabled]="codeForm.invalid">
        <span>{{'NEW_TEXT.verify_account' | translate}}</span>
        <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
      </button>
      </form>
    <div class="wrapper-sign-up-company-fixed" *ngIf="showChangePhone">
      <div class="wrapper-btn-sign-up-company">
        <a (click)="onSubmitChangePhone()">{{'ACCOUNT.change_phone_number' | translate}}</a>
      </div>
    </div>

  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>

